<template>
  <div class="container">
    <b-card header-tag="header">
      <template #header>
        <b-row align-h="between" align-v="center">
          <h4 class="card-tittle">Su Itinerario</h4>
          <b-button variant="dark" @click="back()">Volver </b-button>
        </b-row>
      </template>

      <div v-if="isBusy" class="text-center text-danger space">
        <b-spinner class="align-middle"></b-spinner>
      </div>

      <b-row v-if="!isBusy" align-h="between" align-v="center">
        <!-- INICIO PRIMERA ROW -->
        <b-row align-h="between" align-v="center" class="mainRow">
          <b-col cols="2" class="redCol"> DATOS DE SU {{ nameDetail }} </b-col>
          <b-col cols="5">
            <h5>Lugar de Salida</h5>
            <p>
              Sucursal:
              <b>{{
                data.descSucursalSalida
                  ? data.descSucursalSalida
                  : " No especificada"
              }}</b>
            </p>
            <p>
              Dirección:
              <b>{{
                data.direccionSalida ? data.direccionSalida : "No especificada"
              }}</b>
            </p>
            <p>
              Fecha:
              <b>{{
                data.fechaSalida ? getDate(data.fechaSalida) : "No especificada"
              }}</b>
            </p>
            <p>
              Hora:
              <b>{{
                data.fechaSalida ? getHour(data.fechaSalida) : "No especificada"
              }}</b>
            </p>
          </b-col>
          <b-col cols="5">
            <h5>Lugar de Devolución</h5>
            <p>
              Sucursal:
              <b>{{
                data.descSucursalDevolucion
                  ? data.descSucursalDevolucion
                  : "No especificada"
              }}</b>
            </p>
            <p>
              Dirección:
              <b>{{
                data.direccionDevolucion
                  ? data.direccionDevolucion
                  : "No especificada"
              }}</b>
            </p>
            <p>
              Fecha:
              <b>{{
                data.fechaDevolucion
                  ? getDate(data.fechaDevolucion)
                  : "No especificada"
              }}</b>
            </p>
            <p>
              Hora:
              <b>{{
                data.fechaDevolucion
                  ? getHour(data.fechaDevolucion)
                  : "No especificada"
              }}</b>
            </p>
          </b-col>
        </b-row>
        <!-- INICIO SEGUNDA ROW -->
        <b-row align-h="between" align-v="center" class="mainRow">
          <b-col cols="2" class="redCol"> DATOS DE CONDUCTOR </b-col>
          <b-col cols="10">
            <div v-if="data.conductor">
              <p>
                Nombre conductor:
                <b>{{
                  data.conductor.nombre
                    ? data.conductor.nombre
                    : "No especificado"
                }}</b>
              </p>
              <p>
                Dirección:
                <b>{{
                  data.conductor.direccion
                    ? data.conductor.direccion
                    : "No especificada"
                }}</b>
              </p>
              <p>
                E-mail:
                <b>{{
                  data.conductor.correo
                    ? data.conductor.correo
                    : "No especificado"
                }}</b>
              </p>
            </div>
            <div v-else>
              <p>Nombre conductor: <b>No especificado</b></p>
              <p>Dirección: <b>No especificada</b></p>
              <p>E-mail: <b>No especificado</b></p>
            </div>
          </b-col>
        </b-row>
        <!-- INICIO TERCERA ROW -->
        <b-row align-h="between" align-v="center" class="mainRow">
          <b-col cols="2" class="redCol"> DATOS DEL VEHÍCULO </b-col>
          <b-col cols="5" class="colImg">
            <div v-if="data.vehiculo">
              <img :src="data.vehiculo.imagen" alt="Imagen no disponible" />
            </div>
            <div v-else>
              <img alt="Imagen no disponible" />
            </div>
          </b-col>
          <b-col cols="5">
            <div v-if="data.vehiculo">
              <p>
                Tipo:
                <b>{{
                  data.vehiculo.tipo ? data.vehiculo.tipo : "No especificado"
                }}</b>
              </p>
              <p>
                Categoría:
                <b>{{
                  data.vehiculo.categoria
                    ? data.vehiculo.categoria
                    : "No especificada"
                }}</b>
              </p>
              <p>
                Cantidad de puertas:
                <b>{{
                  data.vehiculo.cantidadPuertas
                    ? data.vehiculo.cantidadPuertas
                    : "No especificado"
                }}</b>
              </p>
              <p>
                Transmisión:
                <b>{{
                  data.vehiculo.transmision
                    ? data.vehiculo.transmision
                    : "No especificado"
                }}</b>
              </p>
            </div>
            <div v-else>
              <p>Tipo: <b>No especificado</b></p>
              <p>Categoría: <b>No especificada</b></p>
              <p>Cantidad de puertas: <b>No especificado</b></p>
              <p>Transmisión: <b>No especificado</b></p>
            </div>
          </b-col>
        </b-row>
      </b-row>

      <!-- Inicio Tabla 1 -->
      <b-row v-if="!isBusy" align-h="between" align-v="center" class="mainRow">
        <div class="table-responsive mb-0 mt-5">
          <b-table
            thead-tr-class="titleTable"
            :items="tableTarifa"
            :fields="fieldsTarifa"
            responsive="sm"
            :striped="true"
            :bordered="true"
          >
            <!-- Inicio Spinner en estado "ocupado" de la tabla 1 -->
            <template #table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
              </div>
            </template>
            <!-- Fin Spinner en estado "ocupado" de la tabla 1 -->

            <template #cell(total)="row"> ${{ row.value }} </template>
            <template slot="bottom-row" slot-scope="">
              <td />
              <td />
              <td />
              <td>Subtotal</td>
              <td>
                ${{
                  data.total ? data.total.encabezadoNeto : "No especificado"
                }}
              </td>
            </template>
          </b-table>
        </div>
      </b-row>
      <!-- Fin Tabla 1 -->

      <!-- Inicio Tabla 2 -->
      <b-row v-if="!isBusy" align-h="between" align-v="center" class="mainRow">
        <div class="table-responsive mb-0 mt-3">
          <h4 class="card-title mb-4">CDW Recargo Apt</h4>
          <b-table
            thead-tr-class="titleTable"
            :items="tableCDW"
            :fields="fieldsCDW"
            responsive="sm"
            :striped="true"
            :bordered="true"
          >
            <!-- Inicio Spinner en estado "ocupado" de la tabla -->
            <template #table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
              </div>
            </template>
            <!-- Fin Spinner en estado "ocupado" de la tabla -->

            <template #cell(total)="row"> ${{ row.value }} </template>
            <template slot="bottom-row" slot-scope="">
              <td />
              <td />
              <td />
              <td>Subtotal</td>
              <td>
                ${{
                  data.total ? data.total.opcionalesNeto : "No especificado"
                }}
              </td>
            </template>
          </b-table>
        </div>
      </b-row>
      <!-- Fin Tabla 2 -->
    </b-card>
  </div>
</template>

<script>
import axios from "@/axios";
import moment from "moment";
export default {
  props: ["id"],
  data() {
    return {
      data: {},
      fieldsTarifa: [
        {
          key: "descripcion",
          label: "Código de tarifa: KL (KILÓMETRO LIBRE)",
          sortable: false,
        },
        {
          key: "cantidad",
          label: "Cantidad",
          sortable: false,
        },
        {
          key: "valor",
          label: "Valor",
          sortable: false,
        },
        {
          key: "moneda",
          label: "Moneda",
          sortable: false,
        },
        {
          key: "total",
          label: "Total",
          sortable: false,
        },
      ],
      tableTarifa: [],
      fieldsCDW: [
        {
          key: "dias",
          label: "Días",
          sortable: false,
        },
        {
          key: "valor",
          label: "Valor",
          sortable: false,
        },
        {
          key: "moneda",
          label: "Moneda",
          sortable: false,
        },
        {
          key: "base",
          label: "Base",
          sortable: false,
        },
        {
          key: "total",
          label: "Total",
          sortable: false,
        },
      ],
      tableCDW: [],
      isBusy: false,
    };
  },
  mounted() {
    this.getDetail();
  },
  computed: {
    nameDetail() {
      const routeName = this.$route.name
      return routeName === 'detalleCotizacion' ? 'COTIZACIÓN' : 'RESERVA'
    }
  },
  methods: {
    getDetail() {
      this.isBusy = true;
      axios
        .get(`${this.getMethod()}${this.$store.getters["hideValue/detailId"]}`)
        .then((detalle) => {
          this.isBusy = false;
          this.data = detalle.data;
          this.tableTarifa = detalle.data.cotizacion.encabezado;
          this.tableCDW = detalle.data.cotizacion.detalle;
        })
        .catch(() => {
          this.$bvToast.toast(
            this.$t("lease.request.error.message").toString(),
            {
              title: this.$t("lease.request.error.nonFound").toString(),
              variant: "danger",
              solid: true,
            }
          );
          this.isBusy = false;
        });
    },
    getDate(date) {
      return moment(date).format("DD-MM-YYYY");
    },
    getHour(date) {
      return moment(date).format("HH:mm:ss");
    },
    getMethod() {
      let pathname = window.location.pathname;
      pathname = pathname.split("/");
      if (pathname[1] == "detalle_reserva") {
        return "GetReservaByNumero/";
      } else if (pathname[1] == "detalle_cotizacion") {
        return "DetalleCotizacion/";
      }
    },
    back() {
      history.back();
    },
  },
};
</script>

<style scoped>
.mainRow {
  width: 100%;
  padding-left: 1em;
  padding-right: 1em;
  padding-bottom: 0.2em;
}
.redCol {
  background-color: #e2231a;
  color: white;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  justify-items: center;
  font-size: 15px;
  font: 200;
  text-align: center;
}
.redRow {
  background-color: #e2231a;
  color: white;
  padding-left: 1em;
  padding-right: 1em;
  margin-bottom: 3em;
}
.card {
  width: 90%;
  margin-left: 5%;
  margin-top: 24px;
}
.card-tittle {
  font-size: 1.5rem;
  padding: 1rem;
  color: white;
}
.colImg {
  text-align: center;
}
.card-header {
  background-color: #e2231a;
}
img {
  height: 200px;
}
.space {
  padding-bottom: 15rem;
  padding-top: 15rem;
}
</style>
